module.exports = __webpack_public_path__ + "media/images/ticket-partners/ticketland-3956b6837cb34c7814c128844baa1bb2.svg";